module.exports = __webpack_public_path__ + "static/media/WiningerSq.88d2d21b.jpg";